import Base_state_class from './../../core/base-state.js';
var instance = null;
class Edit_redo_class {

	constructor() 
	{
		
		//singleton
		if (instance) {
			return instance;
		}
		instance = this;

		this.Base_state = new Base_state_class();
		this.events();
	}
	events()
	{
		var _this = this;
		document.getElementById('redo_button').addEventListener('click', function (event) {
			_this.Base_state.redo();
		});
	}
	redo() {
		this.Base_state.redo();
		
	}
}

export default Edit_redo_class;
